import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { subYears } from "date-fns";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getDataCutoffDate(isUpgraded: boolean): string | null {
  // All users now have unlimited history access
  return null;
}

export function formatDataLimitMessage(isUpgraded: boolean): string {
  if (isUpgraded) return "";
  
  const cutoffDate = getDataCutoffDate(false);
  if (!cutoffDate) return "";
  
  const date = new Date(cutoffDate);
  const formattedDate = date.toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });
  
  return `Showing data from ${formattedDate} onwards. Older data is hidden.`;
}
